import React from "react";
import { useParams } from "react-router-dom";
import outlets from "../data/outlets";
import common from "../data/common";
import GalleryGrid from "../components/GalleryGrid";
import {
    Box,
    Container,
    Typography,
    Grid,
    useMediaQuery,
    useTheme,
    IconButton
} from "@mui/material";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";


const DynamicOutlet = () => {
    const { slug } = useParams();
    const outlet = outlets.find(o => o.slug === slug);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (!outlet) {
        return <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center", // optional: vertical centering
      height: "200px",      // adjust as needed
    }}
  >
    <Typography variant="h5" align="center">
      Opening Soon!
    </Typography>
  </Box>
    }

    return (
        <Box sx={{ bgcolor: "#FFF8E1", py: 6 }}>
            <Container maxWidth="lg">
                <Box sx={{ bgcolor: "#FFF8E1", py: 6 }}>
                    <Container>
                        <Typography variant="h4" align="center" fontWeight="bold" gutterBottom color="#D35400">
                            {outlet.name}
                        </Typography>
                        <Box display="flex" justifyContent="center" gap={2} mb={4}>
                            <IconButton
                                component="a"
                                href={common.facebookLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ color: "#3b5998" }}
                            >
                                <FacebookIcon fontSize="large" />
                            </IconButton>
                            <IconButton
                                component="a"
                                href={common.instagramLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ color: "#E1306C" }}
                            >
                                <InstagramIcon fontSize="large" />
                            </IconButton>
                        </Box>

                        <Grid
                            container
                            spacing={4}
                            sx={{ my: 6 }}
                            key={outlet.id}
                            direction={isMobile ? "column" : "row"}
                            alignItems="center"
                        >
                            {/* Image */}
                            <Grid item xs={12} md={6}>
                                <Box
                                    component="img"
                                    src={outlet.image}
                                    alt={outlet.name}
                                    sx={{
                                        width: "100%",
                                        maxHeight: 350,
                                        objectFit: "cover",
                                        borderRadius: 3,
                                        boxShadow: 2,
                                    }}
                                />
                            </Grid>

                            {/* Details */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ px: 2 }}>
                                    <Typography variant="h6" fontWeight="bold" mb={2} color="primary">
                                        {outlet.name}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Address: </strong>
                                        <a
                                            href={outlet.mapLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#FCA500", textDecoration: "none" }}
                                        >
                                            {outlet.address}
                                        </a>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Phone:</strong> {outlet.phone}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Email:</strong> {outlet.email}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Timings:</strong> {outlet.timings}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Menu: </strong>
                                        <a
                                            href={outlet.menu}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#FCA500", textDecoration: "none" }}
                                        >
                                            Click here
                                        </a>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Order from Swiggy: </strong>
                                        <a
                                            href={outlet.swiggyLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#FCA500", textDecoration: "none" }}
                                        >
                                            Click here
                                        </a>
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        <strong>Order from Zomato: </strong>
                                        <a
                                            href={outlet.zomatoLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#FCA500", textDecoration: "none" }}
                                        >
                                            Click here
                                        </a>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>

                {/* Gallery Section */}
                <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
                    Gallery
                </Typography>
                <GalleryGrid images={outlet.gallery} />
            </Container>
        </Box>
    );
};

export default DynamicOutlet;
